import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock, BarChart } from "lucide-react";
import useApiData from "../hooks/useApiData";

export default function Programs() {

  const [activeCategory, setActiveCategory] = useState("all");
console.log(activeCategory,222222222222222)
  // API endpoint change when tab change
  const endpoint =
    activeCategory === "all"
      ? "/programs"
      : `/programs?category=${activeCategory}`;

  const { data: pageData, loading } = useApiData(endpoint, null);

  const categories = [
    { id: "all", slug:"all",name: "All Programs" },
    ...(pageData?.categories || [])
  ];

  const programs = pageData?.items || [];

  return (
    <div className="min-h-screen bg-[var(--dvx-bg)] pt-24">

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >

            <span className="text-[var(--dvx-primary)] font-oswald text-sm uppercase tracking-widest">
              {pageData?.hero?.badge}
            </span>

            <h1 className="mt-4 font-oswald text-4xl md:text-5xl lg:text-6xl font-bold text-[var(--dvx-text)] uppercase">
              {pageData?.hero?.title}
            </h1>

            <p className="mt-4 text-[var(--dvx-text-muted)] font-manrope text-lg max-w-2xl mx-auto">
              {pageData?.hero?.description}
            </p>

          </motion.div>

          {/* Tabs */}

          <div className="flex flex-wrap justify-center gap-3 mt-12">

            {categories.map((category) => (

              <button
                key={category.id}
                onClick={() => setActiveCategory(category.slug)}
                className={`px-6 py-3 font-oswald text-sm uppercase tracking-wider ${
                  activeCategory === category.slug
                    ? "bg-[var(--dvx-primary)] text-white"
                    : "bg-[var(--dvx-surface)] border border-[var(--dvx-border)]"
                }`}
              >
                {category.name}
              </button>

            ))}

          </div>

        </div>
      </section>

      {/* Programs */}

      <section className="pb-24">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {loading ? (
            <div className="text-center py-20 text-xl">Loading...</div>
          ) : (

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

              {programs.map((program) => (

                <motion.div key={program.slug}>

                  <Link to={`/programs/${program.slug}`}>

                    <div className="program-card border h-full">

                      <div className="relative h-56 overflow-hidden">

                        <img
                          src={program.image}
                          alt={program.name}
                          className="w-full h-full object-cover"
                        />

                        <div className="absolute top-4 left-4">

                          <span className="bg-[var(--dvx-primary)] text-white text-xs px-3 py-1">
                            {program.category}
                          </span>

                        </div>

                      </div>

                      <div className="p-6">

                        <div className="flex gap-4 text-sm">

                          <span className="flex items-center gap-1">
                            <BarChart size={14}/>
                            {program.level}
                          </span>

                          <span className="flex items-center gap-1">
                            <Clock size={14}/>
                            {program.duration}
                          </span>

                        </div>

                        <h3 className="text-2xl font-bold mt-3">
                          {program.name}
                        </h3>

                        <p className="text-sm mt-2">
                          {program.description}
                        </p>

                        <div className="flex justify-between mt-4">

                          <span className="text-xl font-bold">
                            ${program.price}
                          </span>

                          <span className="flex items-center">
                            View Details
                            <ArrowRight size={16} className="ml-2"/>
                          </span>

                        </div>

                      </div>

                    </div>

                  </Link>

                </motion.div>

              ))}

            </div>

          )}

        </div>

      </section>

    </div>
  );
}